import React from 'react';

// Currently, we have to use this icon locally and not add it to Penta because it doesn't meet the standard.
export const BffIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 42 42" fill="none">
    <g filter="url(#filter0_d_361_2469)">
      <path
        d="M31.3889 4C32.2787 4 33 4.72071 33 5.60976L33 35.3902C33 36.2793 32.2787 37 31.3889 37H5.61111C4.72132 37 4 36.2793 4 35.3902L4 5.60976C4 4.72071 4.72132 4 5.61111 4L31.3889 4Z"
        fill="white"
      />
      <path
        d="M32.75 5.60976L32.75 35.3902C32.75 36.141 32.1408 36.75 31.3889 36.75H5.61111C4.85919 36.75 4.25 36.141 4.25 35.3902L4.25 5.60976C4.25 4.85898 4.85919 4.25 5.61111 4.25L31.3889 4.25C32.1408 4.25 32.75 4.85898 32.75 5.60976Z"
        stroke="#E4E5E7"
        strokeWidth="0.5"
      />
    </g>
    <path d="M18 24.8V19.8H7L7 24.8H18Z" fill="#E8F094" />
    <path d="M18 17.8L18 6.8L7 6.8L7 17.8H18Z" fill="#C5C6C9" />
    <path d="M30 24.8V6.8L20 6.8V24.8H30Z" fill="url(#paint0_linear_361_2469)" />
    <g filter="url(#filter1_d_361_2469)">
      <path
        d="M26 11.7143C26 10.7675 26.7675 10 27.7143 10H36.2857C37.2325 10 38 10.7675 38 11.7143V20.2857C38 21.2325 37.2325 22 36.2857 22H27.7143C26.7675 22 26 21.2325 26 20.2857V11.7143Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter2_d_361_2469)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.7143 10.5C27.0437 10.5 26.5 11.0437 26.5 11.7143V20.2857C26.5 20.9563 27.0437 21.5 27.7143 21.5H36.2857C36.9563 21.5 37.5 20.9563 37.5 20.2857V11.7143C37.5 11.0437 36.9563 10.5 36.2857 10.5H27.7143ZM27.7143 10C26.7675 10 26 10.7675 26 11.7143V20.2857C26 21.2325 26.7675 22 27.7143 22H36.2857C37.2325 22 38 21.2325 38 20.2857V11.7143C38 10.7675 37.2325 10 36.2857 10H27.7143Z"
        fill="#E4E5E7"
      />
    </g>
    <path
      d="M32.2791 12.2791C32.2791 12.1249 32.1541 12 32 12C31.8459 12 31.7209 12.1249 31.7209 12.2791C31.7209 14.1808 30.1808 15.7209 28.2791 15.7209C28.1249 15.7209 28 15.8459 28 16C28 16.1541 28.1249 16.2791 28.2791 16.2791C30.1808 16.2791 31.7209 17.8192 31.7209 19.7209C31.7209 19.8751 31.8459 20 32 20C32.1541 20 32.2791 19.8751 32.2791 19.7209C32.2791 17.8192 33.8192 16.2791 35.7209 16.2791C35.8751 16.2791 36 16.1541 36 16C36 15.8459 35.8751 15.7209 35.7209 15.7209C33.8192 15.7209 32.2791 14.1808 32.2791 12.2791Z"
      fill="#222325"
    />
    <path d="M7 26.8H30V28H7V26.8Z" fill="#C5C6C9" />
    <path d="M7 30H30V31.2H7V30Z" fill="#C5C6C9" />
    <path d="M7 33.2H19V34.4H7V33.2Z" fill="#C5C6C9" />
    <defs>
      <filter
        id="filter0_d_361_2469"
        x="0"
        y="0"
        width="37"
        height="41"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_361_2469" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_361_2469" result="shape" />
      </filter>
      <filter
        id="filter1_d_361_2469"
        x="23"
        y="7"
        width="18"
        height="18"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_361_2469" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_361_2469" result="shape" />
      </filter>
      <filter
        id="filter2_d_361_2469"
        x="23"
        y="7"
        width="18"
        height="18"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_361_2469" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_361_2469" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_361_2469"
        x1="20"
        y1="24.8"
        x2="29.9094"
        y2="6.90364"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BBCE00" />
        <stop offset="1" stopColor="#005C25" />
      </linearGradient>
    </defs>
  </svg>
);
